import type { RuntimeKind } from '@app/core/tokens/infrastructure.tokens';

type CapacitorRuntime = {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
};

const getCapacitorRuntime = (): CapacitorRuntime | undefined => {
  const globalObject = globalThis as typeof globalThis & {
    Capacitor?: CapacitorRuntime;
  };

  return globalObject.Capacitor;
};

export const detectRuntimeKind = (): RuntimeKind => {
  const capacitor = getCapacitorRuntime();

  if (capacitor?.isNativePlatform?.()) {
    return 'capacitor';
  }

  if (capacitor?.getPlatform && capacitor.getPlatform() !== 'web') {
    return 'capacitor';
  }

  return 'web';
};

export const shouldEnableServiceWorker = (runtimeKind: RuntimeKind, isDevelopment: boolean): boolean =>
  runtimeKind === 'web' && !isDevelopment;
